var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgC(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3334 8.39941C24.3334 6.19028 22.5426 4.39941 20.3334 4.39941C18.1243 4.39941 16.3334 6.19028 16.3334 8.39941C16.3334 10.6086 18.1243 12.3994 20.3334 12.3994C22.5426 12.3994 24.3334 10.6086 24.3334 8.39941Z",
    fill: "url(#paint0_linear_275_32644)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 17.7327C12.3334 16.9964 11.7365 16.3994 11.0001 16.3994C10.2637 16.3994 9.66675 16.9964 9.66675 17.7327C9.66675 18.4691 10.2637 19.0661 11.0001 19.0661C11.7365 19.0661 12.3334 18.4691 12.3334 17.7327Z",
    fill: "url(#paint1_linear_275_32644)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.3334 21.0661C28.3334 25.1162 25.0502 28.3994 21.0001 28.3994C16.95 28.3994 13.6667 25.1162 13.6667 21.0661C13.6667 17.016 16.95 13.7327 21.0001 13.7327C25.0502 13.7327 28.3334 17.016 28.3334 21.0661ZM17.6667 21.0661L21.0001 24.3994L24.3334 21.0661L21.0001 17.7327L17.6667 21.0661Z",
    fill: "url(#paint2_linear_275_32644)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 9.73275C15 12.6783 12.6122 15.0661 9.66671 15.0661C6.72119 15.0661 4.33337 12.6783 4.33337 9.73275C4.33337 6.78723 6.72119 4.39941 9.66671 4.39941C12.6122 4.39941 15 6.78723 15 9.73275ZM7.66671 9.73275L9.66671 7.73275L11.6667 9.73275L9.66671 11.7327L7.66671 9.73275Z",
    fill: "#76808F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 12.3994C28.3334 13.1358 27.7364 13.7327 27 13.7327C26.2637 13.7327 25.6667 13.1358 25.6667 12.3994C25.6667 11.663 26.2637 11.0661 27 11.0661C27.7364 11.0661 28.3334 11.663 28.3334 12.3994Z",
    fill: "#76808F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3334 24.3994C12.3334 26.6086 10.5425 28.3994 8.33337 28.3994C6.12424 28.3994 4.33337 26.6086 4.33337 24.3994C4.33337 22.1903 6.12424 20.3994 8.33337 20.3994C10.5425 20.3994 12.3334 22.1903 12.3334 24.3994Z",
    fill: "#76808F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_275_32644",
    x1: 19.0001,
    y1: 28.3994,
    x2: 19.0001,
    y2: 4.39941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_275_32644",
    x1: 19.0001,
    y1: 28.3994,
    x2: 19.0001,
    y2: 4.39941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_275_32644",
    x1: 19.0001,
    y1: 28.3994,
    x2: 19.0001,
    y2: 4.39941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8D33A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.7bdc7e1cf05551a6baf7e73f63783dfa.svg";
export { ForwardRef as ReactComponent };